var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-input"},[_c('label',{staticClass:"file-label"},[_c('span',{staticClass:"file-cta"},[_vm._m(0),_c('span',{staticClass:"file-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])]),_c('input',{ref:"input",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.handleFileChange}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"file-icon"},[_c('i',{staticClass:"fas fa-upload"})])
}]

export { render, staticRenderFns }